<template>
  <div class="absolute flex items-center gap-2 top-4 right-6">
    <div
      v-if="!inPlaybook && $route.name !== 'WorkspaceItem' && isModuleActivated(MODULES.WORKSPACE)"
      :class="[{ 'mt-3': interaction.workspaces_shared_in?.length }]">
      <div type="button" class="primary-outline-btn w-fit" @click="shareInteraction(interaction)">
        <Share2 class="w-6 h-6 mr-1 transition ease-in-out duration-side-menu-transition-duration" />
        {{ $t("Share") }}
      </div>
      <div v-if="interaction.workspaces_shared_in?.length" class="text-xs text-common-grey">
        {{ $t("Shared in") }} {{ interaction.workspaces_shared_in?.length }} {{ $t("workspace") }}
      </div>
    </div>

    <div
      v-if="!inPlaybook"
      class="flex items-center justify-center w-8 h-8 ml-2 bg-white border rounded-full cursor-pointer has-tooltip dark:border-dark-divider-border dark:bg-dark-screen-background"
      @click="handleCloseInteraction">
      <X color="#FF0000" class="w-6 h-6 transition ease-in-out duration-side-menu-transition-duration" /><span
        class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
        {{ $t("Close") }}</span>
    </div>
  </div>

  <div class="flex flex-col justify-between flex-1">
    <div class="divide-y divide-gray-200">
      <div class="pt-6 pb-5 space-y-6" :class="{ '!pb-44': inPlaybook }">
        <Form
          v-slot="{ values }"
          :initial-values="initial_values"
          :validation-schema="schema"
          class="mt-2 space-y-6"
          @submit="updateInteraction">
          <div class="flex items-center justify-between gap-1 mb-5 rounded-lg">
            <SelectInput
              :disabled="editing_disabled"
              label-attr="label"
              value-attr="value"
              :class="$store.state.data.interaction_types.filter((x) => x.value == values['type'])[0]?.categories?.length && 'w-[100%]'"
              class="w-[50%]"
              name="type"
              :input-classes="'text-left'"
              :is-box-background="true"
              :show-label="true"
              :allow-null="false"
              :items="$store.state.data.interaction_types"
              :label="$t('Interaction type')" />

            <SelectInput
              v-if="$store.state.data.interaction_types.filter((x) => x.value == values['type'])[0]?.categories?.length"
              :disabled="editing_disabled"
              :value="values['category']"
              :is-box-background="true"
              :error="category_error_message"
              class="w-[50%] relative z-50"
              label-attr="label"
              value-attr="value"
              :label="$t('Category')"
              :input-classes="'text-left'"
              :show-label="true"
              name="category"
              :allow-null="false"
              :items="$store.state.data.interaction_types.filter((x) => x.value == values['type'])[0].categories" />

            <!-- <p v-if="interaction_types.filter((x) => x.value == values['categories']).length > 0" class="p-2 text-sm leading-7 text-left text-gray-500">
              {{ interaction_types.filter((x) => x.value == values["categories"]) }}
            </p> -->

            <div v-if="!inPlaybook" class="relative w-full">
              <label
                for="d_date"
                class="absolute z-10 block px-1 text-sm transition-all ease-in-out -translate-y-1/2 rounded-full h-fit dark:text-dark-search-bar-text dark:text-dark-body-text left-2 duration-side-menu-transition-duration"
                :class="[
                  inputIsFocused || !!interaction_date ? 'top-0' : 'top-1/2',
                  isBoxBackgroud
                    ? 'bg-light-box-background dark:bg-dark-box-background'
                    : 'bg-white text-gray-400 dark:bg-dark-box-background',
                  inputIsFocused ? 'text-light-brand-blue dark:text-dark-brand-blue' : ''
                ]">{{ $t("Date") }}</label>
              <div class="rounded-md shadow-sm">
                <DatePicker
                  ref="interaction_date"
                  v-model="interaction_date"
                  :is-dark="$store.state.ui.darkMode"
                  class="bg-white dark:bg-dark-screen-background"
                  is-inline
                  mode="date"
                  :popover="{ visibility: 'click' }">
                  <template #default="{ inputValue, inputEvents }">
                    <div class="relative">
                      <svg
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        class="absolute w-4 h-full mx-2 text-gray-600 pointer-events-none">
                        <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>

                      <input
                        id="d_date"
                        :disabled="editing_disabled"
                        :value="inputValue"
                        autocomplete="off"
                        class="w-full h-10 px-10 pl-8 pr-2 transition ease-in-out border rounded-lg outline-none text-light-body-text dark:text-dark-body-text border-light-divider-border dark:border-dark-divider-border focus:ring-1 focus:outline-none focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue duration-side-menu-transition-duration"
                        :class="[
                          !isBoxBackgroud
                            ? 'bg-light-box-background dark:bg-dark-box-background'
                            : 'bg-light-screen-background dark:bg-dark-box-background'
                        ]"
                        @focusin="focusInput"
                        @focusout="focusInput"
                        v-on="inputEvents"
                        @input="
                          $utils.debounce(() => {
                            interaction_date = $event.target.value
                          }, 800)
                        ">
                    </div>
                  </template>

                  <template #footer>
                    <div class="flex items-center justify-end w-full pb-2 pr-2 mt-0">
                      <button v-if="interaction_date" type="button" class="cancel-btn inline-block" @click.stop="emptyDate">
                        {{ $t("Clear") }}
                      </button>
                      <button type="button" class="inline-block cancel-btn" @click.stop="clearDate">{{ $t("Cancel") }}</button>
                    </div>
                  </template>
                </DatePicker>
              </div>
            </div>
          </div>

          <div v-if="inPlaybook" class="relative w-full">
            <label
              for="d_date"
              class="absolute z-10 block px-1 text-sm transition-all ease-in-out -translate-y-1/2 rounded-full h-fit dark:text-dark-search-bar-text dark:text-dark-body-text left-2 duration-side-menu-transition-duration"
              :class="[
                inputIsFocused || !!interaction_date ? 'top-0' : 'top-1/2',
                isBoxBackgroud
                  ? 'bg-light-box-background dark:bg-dark-box-background'
                  : 'bg-white text-gray-400 dark:bg-dark-box-background',
                inputIsFocused ? 'text-light-brand-blue dark:text-dark-brand-blue' : ''
              ]">{{ $t("Date") }}</label>
            <div class="rounded-md shadow-sm">
              <DatePicker
                v-model="interaction_date"
                :is-dark="$store.state.ui.darkMode"
                class="bg-white dark:bg-dark-screen-background"
                is-inline
                mode="date"
                :popover="{ visibility: 'click' }">
                <template #default="{ inputValue, inputEvents }">
                  <div class="relative">
                    <svg
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      class="absolute w-4 h-full mx-2 text-gray-600 pointer-events-none">
                      <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>

                    <input
                      id="d_date"
                      :disabled="editing_disabled"
                      :value="inputValue"
                      autocomplete="off"
                      class="w-full h-10 px-10 pl-8 pr-2 transition ease-in-out border rounded-lg outline-none text-light-body-text dark:text-dark-body-text border-light-divider-border dark:border-dark-divider-border focus:ring-1 focus:outline-none focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue duration-side-menu-transition-duration"
                      :class="[
                        !isBoxBackgroud
                          ? 'bg-light-box-background dark:bg-dark-box-background'
                          : 'bg-light-screen-background dark:bg-dark-box-background'
                      ]"
                      @focusin="focusInput"
                      @focusout="focusInput"
                      v-on="inputEvents"
                      @input="
                        $utils.debounce(() => {
                          interaction_date = $event.target.value
                        }, 800)
                      ">
                  </div>
                </template>
              </DatePicker>
            </div>
          </div>

          <div v-if="values['type'] == 'meeting'" :class="{ flex: !inPlaybook }">
            <SelectInput
              v-model:current-item="start_time"
              :disabled="editing_disabled"
              :value="start_time"
              :error="start_time_error_message"
              name="start"
              :items="start_time_options.slice(0, start_time_options.length - 1)"
              :label="$t('Start Time')"
              :label-attr="null"
              :value-attr="null"
              :placeholder="$t('Start Time')"
              class="z-1 min-w-[200px]"
              input-classes="z-1 w-[180px] sm:text-sm appearance-none font-medium text-gray-700 text-left block border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light " />

            <div v-if="start_time && !inPlaybook" class="relative mt-2 ml-3 mr-2 text-common-grey">
              -
            </div>

            <SelectInput
              v-if="start_time"
              v-model:current-item="end_time"
              :class="{ 'mt-2': inPlaybook }"
              :disabled="editing_disabled"
              :value="end_time"
              :error="end_time_error_message"
              name="end"
              :items="end_time_options"
              :label="$t('End Time')"
              :label-attr="null"
              :value-attr="null"
              :placeholder="$t('End Time')"
              class="z-1 min-w-[260px]"
              input-classes="z-1 w-[180px] sm:text-sm appearance-none font-medium text-gray-700 text-left block border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light " />
          </div>

          <div class="w-1/2 -mt-6">
            <CompaniesSelect
              :short-king="inPlaybook"
              :multi-select="inPlaybook ? true : false"
              :label="$t('Company/Opportunity')"
              :disabled="isTemplate"
              :autocomplete-options="resultReferencesList"
              :companies="selected_company ? [selected_company] : selected_companies ? selected_companies : []"
              @changed="
                ($event) => {
                  handleSetConmpaniesList($event)
                }
              " />
          </div>

          <div class="flex w-full">
            <div class="w-1/2 mt-3 mb-5">
              <TeamMembersSelect
                v-model:selected-team-members="selected_users"
                :autocomplete-options="autocompleteOptionsInPlaybook"
                :disabled="editing_disabled || isTemplate"
                :label="$t('Team Members')" />
            </div>
            <div v-if="!inPlaybook" class="w-1/2 mt-3 mb-5">
              <ContactsSelect
                v-model:selected-contacts="selected_contacts"
                :disabled="editing_disabled || isTemplate"
                :label="$t('Contacts')"
                :companies="[selected_company]" />
            </div>
          </div>

          <div class="relative rounded-md shadow-sm border p-2 mt-2">
            <div class="flex items-center justify-between w-full">
              <label class="block text-common-grey">{{ $t("Tags") }}</label>
              <button class="primary-btn w-fit" @click.prevent="is_tags_modal_open = true">
                <Plus class="w-6 h-6 mr-2" aria-hidden="true" />
                <span>{{ selected_tags.length ? $t("Edit Tags") : $t("Add Tags") }}</span>
              </button>
            </div>
            <div v-if="selected_tags.length" class="flex flex-wrap gap-2 mt-4">
              <div
                v-for="tag in selected_tags"
                :key="tag?.id"
                class="flex focus:outline-none rounded-md"
                :style="{ background: all_tags.find((t) => t.id == tag.id)?.color }">
                <div v-if="selected_tags.find((t) => t.id == tag.id)" class="flex items-center group">
                  <span
                    class="flex items-center rounded-md px-2 py-1.5 border border-gray-300"
                    :style="{
                      background: all_tags.find((t) => t.id == tag.id)?.color
                    }">
                    <span class="block text-white truncate">{{ tag.name }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="flex items-center mt-4 gap-x-2">
            <label class="relative text-common-grey top-4">{{ $t("Assigned tasks") }}:</label>

            <div
              v-if="related_tasks_displayed.length || tasks_filter_active"
              :class="{ 'pointer-events-none opacity-0': inPlaybook }"
              class="ml-auto w-fit primary-btn"
              @click="handleFilterTasks">
              <Funnel class="w-5 h-5 mr-2 text-white" />{{ tasks_filter_active ? $t("Clear filter") : $t("Filter tasks") }}
            </div>

            <div
              v-if="!isTemplate && !inPlaybook"
              class="btn w-fit primary-btn"
              :class="[`${tasks_filter_applied ? 'bg-gray-300' : ''} `]"
              @click="!isTemplate && !inPlaybook ? handleCreateTask() : null">
              {{ $t("Create New Task") }}
            </div>

            <Menu
              v-if="!editing_disabled"
              v-slot="{ close }"
              ref="goalsMenu"
              as="div"
              class="relative flex-shrink-0"
              :class="[
                `${!related_tasks_displayed.length && !tasks_filter_active ? 'ml-auto' : ''} ${
                  tasks_filter_applied ? 'pointer-events-none' : ''
                } `
              ]">
              <MenuButton
                class="inline-flex items-center justify-center rounded-full w-fit border-1 focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue">
                <div class="btn primary-btn" :class="[`${tasks_filter_applied ? 'bg-gray-300' : ''} `]">
                  {{ $t("Add Task to Interaction") }}
                </div>
              </MenuButton>
              <transition
                enter-active-class="transition duration-100 ease-out"
                enter-from-class="transform scale-95 opacity-0"
                enter-to-class="transform scale-100 opacity-100"
                leave-active-class="transition duration-75 ease-in"
                leave-from-class="transform scale-100 opacity-100"
                leave-to-class="transform scale-95 opacity-0">
                <MenuItems class="absolute z-50 w-40 mx-3 mt-3 -ml-48 origin-bottom-right bg-transparent border-0 focus:outline-none">
                  <div class="py-1 bg-white dark:bg-dark-screen-background p-3 border dark:border-dark-divider-border rounded-lg w-[340px]">
                    <div>
                      <AsyncAutoCompleteInput
                        :add="false"
                        :add-label="$t('Create Task')"
                        :clear-on-select="true"
                        :is-box-background="true"
                        classes="w-full"
                        input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm "
                        name="task"
                        value-attr="id"
                        :endpoint="`/api/organizations/${$store.state.organization.id}/tasks/${interaction.id ? `?target_interaction=${interaction.id}` : ``}`"
                        type="text"
                        :placeholder="$t('Search for task to add')"
                        :debounce="500"
                        @chosen="
                          ($event) => {
                            handleTaskSelected($event, close)
                          }
                        " />
                    </div>
                    <div
                      v-if="!inPlaybook"
                      class="mt-3 mb-3 btn primary-btn"
                      @click="
                        () => {
                          close()
                          handleCreateTask()
                        }
                      ">
                      + {{ $t("Create New Task") }}
                    </div>
                  </div>
                </MenuItems>
              </transition>
            </Menu>
          </div>

          <div v-if="tasks_filter_active">
            <div class="grid items-center justify-center grid-cols-6 gap-x-1">
              <div>
                <MultiSelectInput
                  v-model:current-items="tasks_status"
                  name="tasks_status"
                  :items="$store.state.data?.task_statuses"
                  label-attr="name"
                  value-attr="value"
                  :allow-null="true"
                  :label="$t('Status')"
                  classes="w-full"
                  input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
                  :selection-text="null"
                  :placeholder="$t('Status')"
                  :show-label="false" />
              </div>

              <div class="flex w-full ml-auto rounded-md shadow-sm">
                <div class="relative flex items-stretch flex-grow focus-within:z-10">
                  <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <Search class="w-5 h-5 text-gray-400" aria-hidden="true" />
                  </div>
                  <TextInput
                    :value="tasks_search_term"
                    input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                    name="task_name"
                    type="text"
                    :validate-on-input="true"
                    :label="$t('name')"
                    @update:modelValue="
                      (e) => {
                        tasks_search_term = e
                      }
                    " />
                </div>
              </div>

              <div>
                <AsyncMultiSelectCompaniesInput
                  :add-label="$t('Companies')"
                  :clear-on-select="true"
                  :is-box-background="true"
                  classes="w-full -mt-1"
                  input-classes="appearance-none text-left block w-full px-3 py-2 !border !border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm "
                  name="companies"
                  value-attr="id"
                  :endpoint="`/api/organizations/${$store.state.organization.id}/records/filter/`"
                  endpoint-method="post"
                  search-field="name"
                  type="text"
                  :placeholder="$t('Companies')"
                  @update:currentItems="
                    ($event) => {
                      handleTasksCompaniesSelected($event)
                    }
                  " />
              </div>

              <div>
                <AsyncMultiSelectContactsInput
                  :add-label="$t('Contacts')"
                  :clear-on-select="true"
                  :is-box-background="true"
                  classes="w-full -mt-1"
                  input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm "
                  name="companies"
                  value-attr="id"
                  :endpoint="`/api/organizations/${$store.state.organization.id}/records/filter/`"
                  endpoint-method="post"
                  search-field="name"
                  type="text"
                  :placeholder="$t('Contacts')"
                  @update:currentItems="
                    ($event) => {
                      handleTasksContactsSelected($event)
                    }
                  " />
              </div>

              <div>
                <MultiSelectInput
                  v-model:current-items="tasks_assigned_to"
                  name="tasks_assigned_to"
                  :items="$store.state.data?.users"
                  label-attr="full_name"
                  :allow-null="true"
                  value-attr="id"
                  :label="$t('Users')"
                  classes="w-full dark:text-dark-body-text"
                  input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
                  selection-text="Members (%COUNT)"
                  :placeholder="$t('Team members')"
                  :show-label="false" />
              </div>

              <div>
                <DatePicker
                  v-model="tasks_due_date_range"
                  :is-dark="$store.state.ui.darkMode"
                  :input-debounce="500"
                  mode="range"
                  class="ml-auto bg-white dark:bg-dark-screen-background"
                  :attributes="[
                    {
                      key: 'today',
                      dot: true,
                      dates: new Date()
                    }
                  ]"
                  :popover="{ visibility: 'click' }"
                  is-range
                  range>
                  <template #default="{ inputValue, inputEvents, hidePopover }">
                    <div class="relative flex-grow">
                      <svg
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        class="absolute w-4 h-full mx-2 text-gray-500 pointer-events-none">
                        <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>

                      <button
                        v-if="tasks_due_date_range && tasks_due_date_range.start"
                        class="absolute right-0 flex items-center justify-center w-6 h-6 mx-2 rounded-full top-2 group hover:bg-gray-300"
                        type="button"
                        @click="tasks_due_date_range = null">
                        <X class="w-5 h-5 text-gray-400 group-hover:cursor-pointer" aria-hidden="true" />
                      </button>

                      <input
                        :value="tasks_due_date_range && tasks_due_date_range.start ? `${inputValue.start} - ${inputValue.end}` : ''"
                        placeholder="Due date"
                        class="w-full px-10 py-2 pl- pr-2 text-sm font-medium text-gray-500 placeholder-gray-400 bg-white border border-gray-300 rounded outline-none dark:bg-dark-box-background dark:border-dark-divider-border focus:ring-1 focus:ring-blue-light focus:border-blue-light"
                        @blur="hidePopover"
                        v-on="inputEvents.start || inputEvents.end"
                        @input="
                          $utils.debounce(() => {
                            tasks_due_date_range = $event.target.value
                          }, 300)
                        ">
                    </div>
                  </template>
                </DatePicker>
              </div>
            </div>
          </div>

          <div
            v-if="!related_tasks_displayed.length"
            class="relative w-full p-4 mb-4 text-center border rounded-lg top-4 dark:border-dark-divider-border text-common-grey">
            <div class="text-lg">
              {{ $t("No tasks to display") }}
            </div>
            <div v-if="!tasks_filter_applied" class="mt-1 text-sm">
              {{ $t("Add new tasks to interaction") }}
            </div>
            <div v-else class="mt-1 text-sm">
              {{ $t("No tasks matching filter") }}
            </div>
          </div>

          <div :class="[`grid ${full_screen ? 'grid-cols-2' : 'grid-cols-1'} gap-x-8 mt-5`]">
            <div>
              <div v-for="task in related_tasks_displayed.slice(0, Math.ceil(related_tasks_displayed.length / 2))" :key="task.id">
                <div
                  v-if="expanded_tasks.includes(task.id)"
                  class="relative p-4 mb-4 bg-white border rounded-md dark:bg-dark-box-background dark:border-dark-divider-border dark:text-white"
                  @mouseenter="handleTaskEnter(task)"
                  @mouseleave="handleTaskLeave">
                  <div class="flex items-center">
                    <ToggleStatusButton :object="task" :disable-toggle="task.filter" />

                    <div class="ml-2">
                      {{ task.name }}
                    </div>
                    <div class="absolute flex -right-3 -top-3 gap-x-2">
                      <div
                        class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                        @click="handleExpandTask(task)">
                        <div class="w-[15px] h-[15px] ml-[5px] mt-[0px] border-b-[3px] border-b-[#45D72D]" />
                        <span
                          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                          {{ $t("Minimize") }}</span>
                      </div>
                      <div
                        class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
                        @click="handleViewTask(task)">
                        <Maximize2
                          class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration"
                          color="#2DA7D7" />
                        <span
                          class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
                          {{ $t("View Task") }}</span>
                      </div>
                      <div
                        v-if="!editing_disabled"
                        class="flex items-center justify-center bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                        @click="handleRemoveTask(task)">
                        <X color="#FF0000" class="w-5 h-5 transition ease-in-out duration-side-menu-transition-duration" /><span
                          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                          {{ $t("Remove") }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="flex w-full mt-5">
                    <div class="w-1/3">
                      <div class="flex flex-row items-center gap-2">
                        <div class="text-common-grey">
                          {{ $t("Priority") }}:
                        </div>

                        <div class="flex items-start justify-start w-1/12 py-2 text-start whitespace-nowrap text-md">
                          <div v-if="task.priority" class="flex items-center capitalize gap-x-2">
                            <div>
                              {{ task.priority }}
                            </div>
                            <div>
                              <div v-if="task.priority == $t('normal')">
                                <div :class="[`border-b-2 w-3  border-status-warning-yellow`]" />
                                <div :class="[`border-b-2 w-3 mt-1 border-status-warning-yellow`]" />
                              </div>
                              <div v-else-if="task.priority == $t('high')">
                                <ChevronRight class="w-5 h-5 -rotate-90 text-status-error-red" />
                              </div>
                              <div v-else-if="task.priority == $t('highest')">
                                <ChevronsRight class="w-5 h-5 -rotate-90 text-status-error-red" />
                              </div>
                              <div v-else-if="task.priority == $t('low')">
                                <ChevronRight class="w-5 h-5 rotate-90 text-status-success-green" />
                              </div>
                              <div v-else-if="task.priority == $t('lowest')">
                                <ChevronsRight class="w-5 h-5 rotate-90 text-status-success-green" />
                              </div>
                            </div>
                          </div>

                          <span v-else> - </span>
                        </div>
                      </div>
                    </div>

                    <div class="w-1/3">
                      <div class="flex flex-row items-center gap-2">
                        <div class="text-common-grey whitespace-nowrap">
                          {{ $t("Due Date") }}:
                        </div>

                        <div class="flex items-start justify-start w-1/12 py-2 text-start whitespace-nowrap text-md">
                          <span v-if="task.due_date">
                            {{ $moment(task.due_date).format("DD MMM  YYYY") }}
                          </span>

                          <span v-else> - </span>
                        </div>
                      </div>
                    </div>

                    <div :class="[`${task.assigned_to.length > 4 ? 'w-[16%]' : ''}`]" class="ml-auto -mt-8">
                      <div
                        :class="[`${task.assigned_to.length > 4 ? '' : '-ml-10'}`]"
                        class="mb-2 text-common-grey whitespace-nowrap text-start">
                        {{ $t("Team Members") }}
                      </div>
                      <div class="flex items-center -ml-5 -space-x-4 overflow-hidden">
                        <span v-for="user in task.assigned_to.slice(0, 4)" :key="user" class="inline-block has-tooltip">
                          <img
                            v-if="$utils.getUserById(user, 'avatar')"
                            class="inline-block rounded-full h-9 w-9 object-cover"
                            :src="$utils.getUserById(user, 'avatar')"
                            alt="">
                          <Avatar
                            v-else
                            :first-name="$utils.getUserById(user, 'first_name')"
                            :last-name="$utils.getUserById(user, 'last_name')" />
                          <span class="p-1 bg-gray-300 rounded-sm tooltip whitespace-nowrap">
                            <div class="">
                              <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                                {{ $utils.getUserById(user, "full_name") }}
                              </p>
                            </div>
                          </span>
                        </span>
                        <span
                          v-if="task.assigned_to.length > 4"
                          class="relative ml-auto text-sm left-6 text-light-brand-blue dark:text-dark-brand-blue">
                          + {{ task.assigned_to.length - 4 }} {{ $t("more") }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="relative flex p-4 mb-4 align-middle bg-white border rounded-md dark:bg-dark-box-background dark:border-dark-divider-border dark:text-white"
                  @mouseenter="handleTaskEnter(task)"
                  @mouseleave="handleTaskLeave">
                  <div
                    :class="[
                      'w-4 h-4 rounded-full mt-1 mr-4 relative',
                      {
                        'bg-dark-brand-blue': ['in-progress', 'pending'].includes(task.status),
                        'bg-status-warning-yellow': task.status == 'overdue',
                        'bg-status-success-green': task.status == 'completed',
                        'bg-status-error-red': ['cancelled', 'missed'].includes(task.status)
                      }
                    ]" />
                  <div>{{ task.name }}</div>

                  <div class="absolute flex -right-3 -top-3 gap-x-2">
                    <div
                      class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                      @click="handleExpandTask(task)">
                      <div class="w-[15px] h-[15px] ml-[5px] mt-[5px] border-[3px] rounded-md border-[#45D72D]" />
                      <span
                        class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                        {{ $t("Expand") }}</span>
                    </div>
                    <div
                      class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
                      @click="handleViewTask(task)">
                      <Maximize2
                        class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration"
                        color="#2DA7D7" />
                      <span
                        class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
                        {{ $t("View Task") }}</span>
                    </div>
                    <div
                      v-if="!editing_disabled"
                      class="flex items-center justify-center bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                      @click="handleRemoveTask(task)">
                      <X color="#FF0000" class="w-5 h-5 transition ease-in-out duration-side-menu-transition-duration" /><span
                        class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                        {{ $t("Remove") }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div v-for="task in related_tasks_displayed.slice(Math.round(related_tasks_displayed.length / 2), length)" :key="task.id">
                <div
                  v-if="expanded_tasks.includes(task.id)"
                  class="relative p-4 mb-4 bg-white border rounded-md dark:bg-dark-box-background dark:border-dark-divider-border dark:text-white"
                  @mouseenter="handleTaskEnter(task)"
                  @mouseleave="handleTaskLeave">
                  <div class="flex items-center">
                    <ToggleStatusButton :object="task" :disabled="task.filter" />

                    <div class="ml-2">
                      {{ task.name }}
                    </div>
                    <div class="absolute flex -right-3 -top-3 gap-x-2">
                      <div
                        class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                        @click="handleExpandTask(task)">
                        <div class="w-[15px] h-[15px] ml-[5px] mt-[0px] border-b-[3px] border-b-[#45D72D]" />
                        <span
                          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                          {{ $t("Minimize") }}</span>
                      </div>
                      <div
                        class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
                        @click="handleViewTask(task)">
                        <Maximize2
                          class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration"
                          color="#2DA7D7" />
                        <span
                          class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
                          {{ $t("View Task") }}</span>
                      </div>
                      <div
                        v-if="!editing_disabled"
                        class="flex items-center justify-center bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                        @click="handleRemoveTask(task)">
                        <X color="#FF0000" class="w-5 h-5 transition ease-in-out duration-side-menu-transition-duration" /><span
                          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                          {{ $t("Remove") }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="flex w-full mt-5">
                    <div class="w-1/3">
                      <div class="flex flex-row items-center gap-2">
                        <div class="text-common-grey">
                          {{ $t("Priority") }}:
                        </div>

                        <div class="flex items-start justify-start w-1/12 py-2 text-start whitespace-nowrap text-md">
                          <div v-if="task.priority" class="flex items-center capitalize gap-x-2">
                            <div>
                              {{ task.priority }}
                            </div>
                            <div>
                              <div v-if="task.priority == $t('normal')">
                                <div :class="[`border-b-2 w-3  border-status-warning-yellow`]" />
                                <div :class="[`border-b-2 w-3 mt-1 border-status-warning-yellow`]" />
                              </div>
                              <div v-else-if="task.priority == $t('high')">
                                <ChevronRight class="w-5 h-5 -rotate-90 text-status-error-red" />
                              </div>
                              <div v-else-if="task.priority == $t('highest')">
                                <ChevronsRight class="w-5 h-5 -rotate-90 text-status-error-red" />
                              </div>
                              <div v-else-if="task.priority == $t('low')">
                                <ChevronRight class="w-5 h-5 rotate-90 text-status-success-green" />
                              </div>
                              <div v-else-if="task.priority == $t('lowest')">
                                <ChevronsRight class="w-5 h-5 rotate-90 text-status-success-green" />
                              </div>
                            </div>
                          </div>

                          <span v-else> - </span>
                        </div>
                      </div>
                    </div>

                    <div class="w-1/3">
                      <div class="flex flex-row items-center gap-2">
                        <div class="text-common-grey whitespace-nowrap">
                          {{ $t("Due Date") }}:
                        </div>

                        <div class="flex items-start justify-start w-1/12 py-2 text-start whitespace-nowrap text-md">
                          <span v-if="task.due_date">
                            {{ $moment(task.due_date).format("DD MMM  YYYY") }}
                          </span>

                          <span v-else> - </span>
                        </div>
                      </div>
                    </div>

                    <div :class="[`${task.assigned_to.length > 4 ? 'w-[16%]' : ''}`]" class="ml-auto -mt-8">
                      <div
                        :class="[`${task.assigned_to.length > 4 ? '' : '-ml-10'}`]"
                        class="mb-2 text-common-grey whitespace-nowrap text-start">
                        {{ $t("Team Members") }}
                      </div>
                      <div class="flex items-center -ml-5 -space-x-4 overflow-hidden">
                        <span v-for="user in task.assigned_to.slice(0, 4)" :key="user" class="inline-block has-tooltip">
                          <img
                            v-if="$utils.getUserById(user, 'avatar')"
                            class="inline-block rounded-full h-9 w-9 object-cover"
                            :src="$utils.getUserById(user, 'avatar')"
                            alt="">
                          <Avatar
                            v-else
                            :first-name="$utils.getUserById(user, 'first_name')"
                            :last-name="$utils.getUserById(user, 'last_name')" />
                          <span class="p-1 bg-gray-300 rounded-sm tooltip whitespace-nowrap">
                            <div class="">
                              <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                                {{ $utils.getUserById(user, "full_name") }}
                              </p>
                            </div>
                          </span>
                        </span>
                        <span
                          v-if="task.assigned_to.length > 4"
                          class="relative ml-auto text-sm left-6 text-light-brand-blue dark:text-dark-brand-blue">
                          + {{ task.assigned_to.length - 4 }} {{ $t("more") }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="relative flex p-4 mb-4 align-middle bg-white border rounded-md dark:bg-dark-box-background dark:border-dark-divider-border dark:text-white"
                  @mouseenter="handleTaskEnter(task)"
                  @mouseleave="handleTaskLeave">
                  <div
                    :class="[
                      'w-4 h-4 rounded-full mt-1 mr-4 relative',
                      {
                        'bg-dark-brand-blue': ['in-progress', 'pending'].includes(task.status),
                        'bg-status-warning-yellow': task.status == 'overdue',
                        'bg-status-success-green': task.status == 'completed',
                        'bg-status-error-red': ['cancelled', 'missed'].includes(task.status)
                      }
                    ]" />
                  <div>{{ task.name }}</div>

                  <div class="absolute flex -right-3 -top-3 gap-x-2">
                    <div
                      class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                      @click="handleExpandTask(task)">
                      <div class="w-[15px] h-[15px] ml-[5px] mt-[5px] border-[3px] rounded-md border-[#45D72D]" />
                      <span
                        class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                        {{ $t("Expand") }}</span>
                    </div>
                    <div
                      class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
                      @click="handleViewTask(task)">
                      <Maximize2
                        class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration"
                        color="#2DA7D7" />
                      <span
                        class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
                        {{ $t("View Task") }}</span>
                    </div>
                    <div
                      v-if="!editing_disabled"
                      class="flex items-center justify-center bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                      @click="handleRemoveTask(task)">
                      <X color="#FF0000" class="w-5 h-5 transition ease-in-out duration-side-menu-transition-duration" /><span
                        class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                        {{ $t("Remove") }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex items-center w-full">
            <div v-if="tasks_count > 6" class="mr-2 text-sm text-common-grey">
              {{ $t("Show") }}
            </div>
            <SelectInput
              v-if="tasks_count > 6"
              :value="tasksPerPage"
              :is-box-background="true"
              class="w-[115px]"
              :input-classes="'text-left'"
              name="tasks_page_show_options"
              :allow-null="false"
              :items="tasks_page_show_options"
              @update:currentItem="tasksPerPage = $event" />
            <div v-if="tasks_count > 6" class="ml-2 text-sm text-common-grey">
              {{ $t("in page") }}
            </div>
            <Pagination
              v-if="tasks_count > tasksPerPage"
              class="ml-auto"
              :total-pages="tasks_total_pages"
              :current-page="tasksCurrentPage"
              @input="tasksChangePage" />
          </div>

          <div class="mt-5 border rounded-md dark:border-dark-divider-border h-28">
            <TextEditor
              ref="quill"
              v-model:content="interaction_description"
              :value="interaction_description"
              name="description"
              :label="$t('Description')"
              content-type="html"
              input-classes="rounded-md"
              :mention-items="resultReferencesListForText"
              theme="bubble"
              toolbar="essential" />
          </div>

          <AttachmentsField
            v-model="attachments"
            v-model:deleted-attachments="deleted_attachments"
            v-model:new-attachments="new_attachments"
            :disabled="editing_disabled"
            class="mt-4 mb-6" />

          <div v-if="!editing_disabled" class="flex flex-row justify-between w-full gap-2 mt-2">
            <button :class="{ 'w-1/2': inPlaybook }" type="button" class="w-1/3 m-0 cancel-btn" @click="handleCloseInteraction">
              {{ $t("Cancel") }}
            </button>
            <button
              v-if="!inPlaybook"
              type="button"
              class="w-1/3 delete-btn"
              @click="
                $emitter.emit(ALL_EMITTERS.DELETE_OBJECT, {
                  object: { ...interaction, type: 'Interaction' },
                  objectDeleteCallBack: () => {
                    $emit('cancel')
                  }
                })
              ">
              {{ $t("Delete") }}
            </button>
            <button
              v-if="!isTemplate"
              :class="{ 'w-1/2': inPlaybook }"
              :disabled="submitting_is_on"
              type="submit"
              class="w-1/3 primary-btn"
              @click="
                () => {
                  !inPlaybook ? updateInteraction(values) : null
                }
              ">
              <RotateCw
                :class="{
                  'animate-spin': submitting_is_on,
                  'opacity-100': submitting_is_on
                }"
                class="w-5 h-5 mr-3 -ml-1 opacity-0"
                aria-hidden="true" />
              <span class="mr-5">
                {{ inPlaybook ? $t("Save Interaction") : $t("Update Interaction") }}
              </span>
            </button>
            <button v-else :disabled="submitting_is_on" class="w-1/3 primary-btn" @click.prevent="openSaveTemplateModal(values)">
              <RotateCw
                :class="{
                  'animate-spin': submitting_is_on,
                  'opacity-100': submitting_is_on
                }"
                class="w-5 h-5 mr-3 -ml-1 opacity-0"
                aria-hidden="true" />
              <span class="mr-5"> {{ $t("Save Interaction as Template") }} </span>
            </button>
          </div>
        </Form>
      </div>
    </div>
    <Modal v-model:is-open="is_save_modal_template_open" :default-success-msg="$t('Template created!')" :use-toast="true">
      <template #form="{ close: closeModal, done: showIsDone }">
        <div class="-space-y-px rounded-md shadow-sm">
          <TextInput v-model="template_name"
                     label=""
                     name="template_name"
                     type="text"
                     :placeholder="$t('Template name')" />
        </div>
        <div class="mt-5 flex flex-row-reverse gap-2 justify-start w-full">
          <button type="button" class="w-fit primary-btn" @click="saveTemplate(showIsDone)">{{ $t("Save") }}</button>
          <button
            type="button"
            class="inline-flex items-center justify-center px-4 py-2 ml-2 font-medium border rounded-md dark:text-dark-body-text focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm"
            @click="closeModal">
            {{ $t("Cancel") }}
          </button>
        </div>
      </template>
    </Modal>

    <!-- Add tags -->
    <Modal v-model:is-open="is_tags_modal_open" :default-success-msg="$t('Note deleted')">
      <template #form="{ close: closeModal }">
        <TagsAutoCompleteInput
          :placeholder="$t('Add new tag')"
          value-attr="full_name"
          :selected-tags="selected_tags"
          @changed="
            ($event) => {
              handleTagsChanged($event)
            }
          "
          @close="closeModal" />
      </template>
    </Modal>
  </div>
</template>

<script>
import * as Yup from "yup"
import AsyncMultiSelectCompaniesInput from "@/components/shared/AsyncMultiSelectCompaniesInput.vue"
import AsyncMultiSelectContactsInput from "@/components/shared/AsyncMultiSelectContactsInput.vue"
import MultiSelectInput from "@/components/shared/MultiSelectInput.vue"
import { Menu, MenuButton, MenuItems } from "@headlessui/vue"
import AsyncAutoCompleteInput from "@/components/shared/AsyncAutoCompleteInput.vue"
import ToggleStatusButton from "../shared/ToggleStatusButton.vue"
import Avatar from "@/components/shared/Avatar.vue"
import Pagination from "@/components/shared/Pagination.vue"
import { DatePicker } from "v-calendar"
import Modal from "@/components/shared/Modal.vue"
import SelectInput from "@/components/shared/SelectInput.vue"
import { Form } from "vee-validate"
import TextInput from "@/components/shared/TextInput.vue"
import { Maximize2, Funnel, ChevronsRight, ChevronRight, Share2, Search, X, Plus, RotateCw } from "lucide-vue-next"
import ContactsSelect from "@/components/shared/ContactsSelect.vue"
import TeamMembersSelect from "@/components/shared/TeamMembersSelect.vue"
import TagsAutoCompleteInput from "@/components/shared/TagsAutoCompleteInput.vue"
import CompaniesSelect from "@/components/shared/CompaniesSelect.vue"
import dataService from "@/services/data.service"
import AttachmentsField from "@/components/shared/form-inputs/AttachmentsField.vue"
import { MODULES } from "@/store/constants/references"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import TextEditor from "@/components/shared/TextEditor.vue"
import { useI18n } from "vue-i18n"

export default {
  components: {
    AsyncMultiSelectCompaniesInput,
    AsyncMultiSelectContactsInput,
    MultiSelectInput,
    Funnel,
    Search,
    X,
    ToggleStatusButton,
    AsyncAutoCompleteInput,
    Menu,
    MenuButton,
    MenuItems,
    Maximize2,
    ChevronRight,
    ChevronsRight,
    Avatar,
    Pagination,
    Plus,
    TagsAutoCompleteInput,
    TextEditor,
    TextInput,
    Modal,
    AttachmentsField,
    Share2,
    CompaniesSelect,
    ContactsSelect,
    SelectInput,
    Form,
    TeamMembersSelect,
    RotateCw,
    DatePicker
  },
  inject: ["canUserEditLayout", "isModuleActivated"],

  props: {
    resultReferencesList: null,
    resultReferencesListForText: null,
    autocompleteOptionsInPlaybook: {
      type: Array,
      required: false,
      default: () => []
    },
    inPlaybook: {
      type: Boolean,
      default: false
    },
    isTemplate: {
      type: Boolean,
      default: false
    },
    interaction: {
      type: Object,
      required: true
    }
  },
  emits: ["cancel", "submitted", "done", "error"],
  setup(props) {
    const { t } = useI18n()
    const schema = Yup.object().shape({
      description: Yup.string(),
      type: Yup.string().required(t("Interaction type is required")).nullable()
    })

    const interactions_clone = { ...props.interaction }
    delete interactions_clone.attachments

    const initial_values = interactions_clone

    return {
      schema,
      initial_values
    }
  },
  data() {
    return {
      interaction_data_for_template: {},
      selected_tasks: [],
      tasksCurrentPage: 1,
      tasksPerPage: 6,
      tasks_total_pages: 1,
      tasks_count: 0,
      full_screen: false,
      expanded_tasks: [],
      task_hover_id: null,
      related_tasks_displayed: [],
      assign_companies_to_tasks: false,

      //tasks filters
      tasks_status: null,
      tasks_search_term: "",
      tasks_filter_active: false,
      tasks_companies: [],
      tasks_contacts: [],
      tasks_assigned_to: [],
      tasks_due_date_range: null,
      dont_fetch: false,

      selected_companies: [],
      interaction_description: null,
      ALL_EMITTERS,
      MODULES,
      template_name: null,
      is_save_modal_template_open: false,
      attachments: [],
      deleted_attachments: [],
      new_attachments: [],
      isBoxBackgroud: false,
      category_error_message: "",
      start_time_error_message: null,
      end_time_error_message: null,
      selected_company: null,

      selected_users: [],
      selected_contacts: [],
      selected_tags: [],
      all_tags: [],
      is_tags_modal_open: false,
      submitting_is_on: false,
      interaction_date: new Date(),
      start_time: null,
      end_time: null,
      start_time_options: [
        "12:00 AM",
        "12:15 AM",
        "12:30 AM",
        "12:45 AM",
        "01:00 AM",
        "01:15 AM",
        "01:30 AM",
        "01:45 AM",
        "02:00 AM",
        "02:15 AM",
        "02:30 AM",
        "02:45 AM",
        "03:00 AM",
        "03:15 AM",
        "03:30 AM",
        "03:45 AM",
        "04:00 AM",
        "04:15 AM",
        "04:30 AM",
        "04:45 AM",
        "05:00 AM",
        "05:15 AM",
        "05:30 AM",
        "05:45 AM",
        "06:00 AM",
        "06:15 AM",
        "06:30 AM",
        "06:45 AM",
        "07:00 AM",
        "07:15 AM",
        "07:30 AM",
        "07:45 AM",
        "08:00 AM",
        "08:15 AM",
        "08:30 AM",
        "08:45 AM",
        "09:00 AM",
        "09:15 AM",
        "09:30 AM",
        "09:45 AM",
        "10:00 AM",
        "10:15 AM",
        "10:30 AM",
        "10:45 AM",
        "11:00 AM",
        "11:15 AM",
        "11:30 AM",
        "11:45 AM",
        "12:00 PM",
        "12:15 PM",
        "12:30 PM",
        "12:45 PM",
        "01:00 PM",
        "01:15 PM",
        "01:30 PM",
        "01:45 PM",
        "02:00 PM",
        "02:15 PM",
        "02:30 PM",
        "02:45 PM",
        "03:00 PM",
        "03:15 PM",
        "03:30 PM",
        "03:45 PM",
        "04:00 PM",
        "04:15 PM",
        "04:30 PM",
        "04:45 PM",
        "05:00 PM",
        "05:15 PM",
        "05:30 PM",
        "05:45 PM",
        "06:00 PM",
        "06:15 PM",
        "06:30 PM",
        "06:45 PM",
        "07:00 PM",
        "07:15 PM",
        "07:30 PM",
        "07:45 PM",
        "08:00 PM",
        "08:15 PM",
        "08:30 PM",
        "08:45 PM",
        "09:00 PM",
        "09:15 PM",
        "09:30 PM",
        "09:45 PM",
        "10:00 PM",
        "10:15 PM",
        "10:30 PM",
        "10:45 PM",
        "11:00 PM",
        "11:15 PM",
        "11:30 PM",
        "11:45 PM",
        "12:00 AM"
      ],
      duration_array: [
        "15 mins",
        "30 mins",
        "45 mins",
        "1 hr",
        "1hr 15min",
        "1.5 hrs",
        "1hr 45min",
        "2 hrs",
        "2hr 15min",
        "2.5 hrs",
        "2hr 45min",
        "3 hrs",
        "3hr 15min",
        "3.5 hrs",
        "3hr 45min",
        "4 hrs",
        "4hr 15min",
        "4.5 hrs",
        "4hr 45min",
        "5 hrs",
        "5hr 15min",
        "5.5 hrs",
        "5hr 45min",
        "6 hrs",
        "6hr 15min",
        "6.5 hrs",
        "6hr 45min",
        "7 hrs",
        "7hr 15min",
        "7.5 hrs",
        "7hr 45min",
        "8 hrs",
        "8hr 15min",
        "8.5 hrs",
        "8hr 45min",
        "9 hrs",
        "9hr 15min",
        "9.5 hrs",
        "9hr 45min",
        "10 hrs",
        "10hr 15min",
        "10.5 hrs",
        "10hr 45min",
        "11 hrs",
        "11hr 15min",
        "11.5 hrs",
        "11hr 45min",
        "12 hrs",
        "12hr 15min",
        "12.5 hrs",
        "12hr 45min",
        "13 hrs",
        "13hr 15min",
        "13.5 hrs",
        "13hr 45min",
        "14 hrs",
        "14hr 15min",
        "14.5 hrs",
        "14hr 45min",
        "15 hrs",
        "15hr 15min",
        "15.5 hrs",
        "15hr 45min",
        "16 hrs",
        "16hr 15min",
        "16.5 hrs",
        "16hr 45min",
        "17 hrs",
        "17hr 15min",
        "17.5 hrs",
        "17hr 45min",
        "18 hrs",
        "18hr 15min",
        "18.5 hrs",
        "18hr 45min",
        "19 hrs",
        "19hr 15min",
        "19.5 hrs",
        "19hr 45min",
        "20 hrs",
        "20hr 15min",
        "20.5 hrs",
        "20hr 45min",
        "21 hrs",
        "21hr 15min",
        "21.5 hrs",
        "21hr 45min",
        "22 hrs",
        "22hr 15min",
        "22.5 hrs",
        "22hr 45min",
        "23 hrs",
        "23hr 15min",
        "23.5 hrs",
        "23hr 45min",
        "24 hrs"
      ],
      end_time_options: [],
      inputIsFocused: false
    }
  },
  computed: {
    editing_disabled() {
      let editing_disabled_calc = false
      if (this.$route.name == "WorkspaceItem" && this.$store.state.ui.workspace_user_access_scope == "read") {
        editing_disabled_calc = true
      }

      if (this.$route.name == "Dashboard" && this.$route.params.page) {
        const current_template = this.$store.state.portfolio.shared_layouts.find((l) => l.id == this.$route.params.page)
        if (!this.canUserEditLayout(this.$store.state.auth.user, current_template)) {
          editing_disabled_calc = true
        }
      }

      return editing_disabled_calc
    },
    tasks_filter_applied() {
      if (
        this.tasks_status?.length ||
        this.tasks_search_term ||
        this.tasks_companies.length ||
        this.tasks_contacts.length ||
        this.tasks_assigned_to.length ||
        this.tasks_due_date_range
      ) {
        return true
      } else {
        return false
      }
    },
    tasks_page_show_options() {
      const options = [6]
      if (this.selected_tasks.length > 6) {
        options.push(8)
      }
      if (this.selected_tasks.length > 8) {
        options.push(10)
      }
      if (this.selected_tasks.length > 10) {
        options.push(12)
      }
      return options
    }
  },

  watch: {
    start_time() {
      let index = this.start_time_options.findIndex((x) => x == this.start_time)
      const end_time_array = this.start_time_options.slice(index + 1, this.start_time_options.length)
      this.end_time_options = []
      end_time_array.forEach((time, i) => {
        this.end_time_options.push(`${time} (${this.duration_array[i]})`)
      })
      this.end_time = null
    },
    tasksPerPage: {
      handler() {
        const params = { page_size: this.tasksPerPage, page: 1 }
        if (this.interaction?.id) {
          dataService.getGoalTasks(this.interaction?.id, params).then((res) => {
            this.tasksCurrentPage = 1
            this.related_tasks_displayed = res.data.results
            this.tasksTotalPages(res.data)
          })
        }
      }
    },

    //tasks filter watchers
    tasks_status: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getFilteredGoalTasks()
        }
      }
    },
    tasks_search_term: {
      handler() {
        if (!this.dont_fetch) {
          this.getFilteredGoalTasks()
        }
      }
    },
    tasks_companies: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getFilteredGoalTasks()
        }
      }
    },
    tasks_contacts: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getFilteredGoalTasks()
        }
      }
    },

    tasks_assigned_to: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getFilteredGoalTasks()
        }
      }
    },
    tasks_due_date_range: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getFilteredGoalTasks()
        }
      }
    }
  },

  activated() {
    this.register_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },
  created() {
    this.register_listeners()
    if (this.inPlaybook) {
      const att_calc = []
      this.interaction.attachments?.forEach((attachment_id) => {
        dataService.getAttachment(attachment_id).then((res) => {
          att_calc.push(res.data)
          if (att_calc.length == this.interaction.attachments.length) {
            this.attachments = att_calc
          }
        })
      })
    } else if (this.interaction.attachments) {
      this.attachments = this.interaction.attachments.results
    }

    this.interaction_description = this.interaction.description
    this.$store.dispatch("auth/fetchUsers")
    if (!this.isTemplate) {
      this.interaction.users.map((id) => {
        if (this.$store.state.data.users.concat(this.autocompleteOptionsInPlaybook).find((user) => user.id == id) != -1) {
          this.selected_users.push(this.$store.state.data.users.concat(this.autocompleteOptionsInPlaybook).find((user) => user.id == id))
        }
      })
      this.selected_contacts = this.interaction.contacts
      this.selected_company = this.interaction.record
    }

    if (this.interaction.companies) {
      this.selected_companies = []
      this.interaction.companies.forEach((c) => {
        if (c.includes("$")) {
          this.selected_companies.push(c)
        } else {
          this.$store.dispatch("data/getRecord", c).then((res) => {
            this.selected_companies.push(res.data)
          })
        }
      })
      this.interaction.companies
    }

    if (this.interaction.type == this.$t("meeting") && this.interaction.meta_data) {
      this.start_time = this.$moment.unix(this.interaction.meta_data.when?.start_time).format("hh:mm A")
      let index = this.start_time_options.findIndex((x) => x == this.start_time)
      const end_time_array = this.start_time_options.slice(index + 1, this.start_time_options.length)
      this.end_time_options = []
      end_time_array.forEach((time, i) => {
        this.end_time_options.push(`${time} (${this.duration_array[i]})`)
      })
      const end_time_index = this.end_time_options?.findIndex((t) =>
        t.includes(this.$moment.unix(this.interaction.meta_data.when?.end_time).format("hh:mm A"))
      )
      setTimeout(() => {
        this.end_time = this.end_time_options[end_time_index]
      }, 200)
    }

    if (this.interaction.tags.length > 0) {
      this.all_tags = this.$store.state.data.actions_tags
      this.all_tags.map((tag) => {
        if (this.interaction.tags.find((t) => t == tag.id)) {
          this.selected_tags.push(tag)
        }
      })
    } else {
      this.selected_tags = []
    }

    if (this.interaction.interaction_date) {
      this.interaction_date = this.$moment
        .utc(this.interaction.interaction_date ? this.interaction.interaction_date : this.interaction.datetime_created)
        .local()
        .toDate()
    }
    this.assign_companies_to_tasks = this.interaction.assign_companies_to_tasks
    if (this.interaction?.id) {
      this.tasksTotalPages(this.interaction?.tasks)
    }
    if (this.interaction?.tasks) {
      this.related_tasks_displayed = this.interaction.tasks
    }

    if (this.inPlaybook && this.interaction?.tasks) {
      this.related_tasks_displayed = []
      this.interaction.tasks.forEach((task_id) => {
        dataService.getTask(task_id).then((res) => {
          this.related_tasks_displayed.push(res.data)
        })
      })
    }
  },

  methods: {
    clearDate() {
      this.$refs.interaction_date.hidePopover()
    },

    emptyDate() {
      this.interaction_date = null
      this.$refs.interaction_date.hidePopover()
    },
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.ADD_SELECTED_TASKS_TO_INTERACTION_UPDATE_FORM, (tasks) => {
        this.handleTaskSelected(null, () => {}, tasks)
      })
      this.$emitter.on(ALL_EMITTERS.TASK_UPDATED_IN_INTERACTION_UPDATE_FORM, (task) => {
        let index = this.related_tasks_displayed.findIndex((t) => t.id == task.id)
        this.related_tasks_displayed.splice(index, 1, task)
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.ADD_SELECTED_TASKS_TO_INTERACTION_UPDATE_FORM)
      this.$emitter.off(ALL_EMITTERS.TASK_UPDATED_IN_INTERACTION_UPDATE_FORM)
    },
    getFilteredGoalTasks() {
      let params = {
        page_size: this.tasksPerPage,
        expand: "record",
        ...(!!this.tasks_assigned_to && {
          assigned_to: this.tasks_assigned_to.join(",")
        }),
        ...(!!this.tasks_status && { status: this.tasks_status.join(",") }),
        ...(!!this.tasks_companies?.length && {
          records: this.tasks_companies.map((c) => c.id).join(",")
        }),
        ...(!!this.tasks_contacts && {
          contacts: this.tasks_contacts.map((c) => c.id).join(",")
        })
      }
      // params["prevent_loading"] = true
      if (this.tasks_search_term) {
        params["name"] = this.tasks_search_term
      }
      params["goals"] = this.interaction?.id
      if (this.tasks_due_date_range) {
        params["due_date_start"] = this.$moment(this.tasks_due_date_range.start).format("L")
        params["due_date_end"] = this.$moment(this.tasks_due_date_range.end).format("L")
      }
      this.$store.dispatch("data/getTasks", params).then((res) => {
        this.tasksTotalPages(res.data)
        this.related_tasks_displayed = res.data.results?.map((g) => {
          return {
            ...g,
            filter: g.filter?.split(" ")[0]
              ? g.filter.split(" ")[0].length > 1
                ? `( ${g.filter.slice(1, g.filter.length - 1)} )`
                : g.filter
              : g.filter
          }
        })
      })
    },
    tasksTotalPages(tasks) {
      this.tasks_total_pages = Math.ceil(parseInt(tasks.count) / parseInt(this.tasksPerPage))
      this.tasks_count = tasks.count
    },
    handleTasksContactsSelected(e) {
      this.tasks_contacts = e
    },
    handleTasksCompaniesSelected(e) {
      this.tasks_companies = e
    },
    handleFilterTasks() {
      this.tasks_filter_active = !this.tasks_filter_active
      if (!this.full_screen && this.tasks_filter_active) {
        // this.handleExpandPlan()
      }

      if (!this.tasks_filter_active && this.tasks_filter_applied) {
        this.tasksResetFilters()
      }
    },
    tasksResetFilters() {
      const params = { page_size: this.tasksPerPage, page: 1 }
      dataService.getInteractionTasks(this.interaction?.id, params).then((res) => {
        this.related_tasks_displayed = res.data.results
        this.tasksTotalPages(res.data)
      })
      this.dont_fetch = true
      setTimeout(() => {
        this.dont_fetch = false
      }, 500)
      this.tasks_status = null
      this.tasks_search_term = ""
      this.tasks_companies = []
      this.tasks_assigned_to = []
      this.tasks_due_date_range = null
      this.tasksCurrentPage = 1
    },
    handleTaskSelected(task, close, tasks) {
      if (!this.interaction?.id || this.inPlaybook) {
        this.related_tasks_displayed.push(task)
        close()
      } else {
        dataService
          .addTaskToInteraction(this.interaction?.id, {
            tasks_ids: tasks ? tasks.map((t) => t.id) : [task.id]
          })
          .then(() => {
            this.tasksChangePage(1, true)
          })
        close()
      }
    },
    handleCreateTask() {
      this.$emitter.emit(ALL_EMITTERS.CREATE_TASK, {
        inInteraction: true,
        contact: this.selected_contacts,
        records: [this.selected_company]
      })
    },
    handleTaskEnter(task) {
      this.$utils.debounce(() => {
        this.task_hover_id = task.id
      }, 600)
    },
    handleTaskLeave() {
      this.task_hover_id = null
      this.$utils.debounce(() => {
        this.task_hover_id = null
      }, 600)
    },
    handleExpandTask(task) {
      let index = this.expanded_tasks.findIndex((t) => t == task.id)
      if (index !== -1) {
        this.expanded_tasks.splice(index, 1)
      } else {
        this.expanded_tasks.push(task.id)
      }
    },
    handleViewTask(task) {
      this.$emitter.emit(ALL_EMITTERS.UPDATE_TASK, { task: this.$utils.clone(task) })
    },
    handleRemoveTask(task) {
      dataService.removeTaskFromInteraction(this.interaction?.id, { tasks_ids: [task.id] }).then(() => {
        if (this.related_tasks_displayed.length <= 1 && this.tasksCurrentPage > 1) {
          this.tasksChangePage(this.tasksCurrentPage - 1, true)
        } else {
          this.tasksChangePage(this.tasksCurrentPage, true)
        }
      })
    },
    tasksChangePage(page, calcTotalPages) {
      this.tasksCurrentPage = page
      const params = { page_size: this.tasksPerPage, page: page }
      dataService.getInteractionTasks(this.interaction?.id, params).then((res) => {
        this.related_tasks_displayed = res.data.results
        if (calcTotalPages) {
          this.tasksTotalPages(res.data)
        }
      })
    },
    handleTagsChanged(tags) {
      this.all_tags = this.$store.state.data.actions_tags
      this.selected_tags = tags
    },
    shareInteraction(interaction) {
      this.$emitter.emit(ALL_EMITTERS.SHARE_OBJECT, {
        object: { ...interaction, type: "Interaction" },
        objectDeleteCallBack: () => {
          this.$emit("cancel")
        },
        show_confirmation: true
      })
    },
    handleCloseInteraction() {
      this.$emit("cancel")
    },

    handleSetConmpaniesList(e) {
      if (this.inPlaybook) {
        this.selected_companies = e
      }
      this.selected_company = e[0] ? e[0] : null
    },
    focusInput() {
      this.inputIsFocused = !this.inputIsFocused
    },
    openSaveTemplateModal(values) {
      this.interaction_data_for_template = values
      this.is_save_modal_template_open = true
    },
    saveTemplate(showIsDone) {
      if (this.isTemplate && !this.interaction?.id) {
        let data = {}
        data["name"] = this.template_name
        data["source_object_id"] = null
        data["source_object_type"] = "interaction"

        let template_data = { ...this.interaction_data_for_template }
        delete template_data["name"]
        template_data["organization"] = this.$store.state.organization.id
        template_data["attachments"] = []
        template_data["interaction_date"] = this.$moment(this.interaction_date)
          .set("hour", this.$moment().hour())
          .set("minute", this.$moment().minute())
          .set("second", this.$moment().second())
          .toISOString()
        if (template_data.type == "meeting") {
          template_data["meta_data"] = {
            when: {
              object: "timespan",
              end_time: this.$moment(
                `${this.interaction_date.getFullYear()}-${this.interaction_date.getMonth() + 1}-${this.interaction_date.getDate()} ${
                  this.end_time?.split(" (")[0]
                }`,
                "YYYY-MM-DD hh:mm A"
              ).unix(),
              start_time: this.$moment(
                `${this.interaction_date.getFullYear()}-${this.interaction_date.getMonth() + 1}-${this.interaction_date.getDate()} ${
                  this.start_time
                }`,
                "YYYY-MM-DD hh:mm A"
              ).unix()
            }
          }
        }
        let users = []
        this.selected_users.map((x) => {
          users.push(x.id)
        })
        template_data["users"] = users
        template_data["tags"] = this.selected_tags.map((t) => t.id)
        template_data["description"] = this.interaction_description
        template_data["tasks"] = this.related_tasks_displayed.map((t) => t.id)
        //template_data["content"] = data
        data["content"] = template_data
        dataService.createTemplate(data).then((res) => {
          this.submitting_is_on = false
          this.$emitter.emit(ALL_EMITTERS.NEW_ACTIVITY_TEMPLATE_ADDED, res.data)
          this.$emit("done")
        })
      } else {
        let data = {}
        data["name"] = this.template_name
        data["source_object_id"] = this.interaction.id
        data["source_object_type"] = "interaction"
        dataService.createTemplate(data).then((res) => {
          this.$emitter.emit(ALL_EMITTERS.NEW_ACTIVITY_TEMPLATE_ADDED, res.data)
          this.handleCloseInteraction()
          showIsDone()
        })
      }
    },
    updateInteraction(values) {
      let data = { ...values }
      let users = []
      this.selected_users.map((x) => {
        users.push(x.id)
      })
      data["users"] = users
      data["contacts"] = this.selected_contacts.map((x) => x.id)
      data["tags"] = this.selected_tags.map((t) => t.id)
      data["tasks"] = this.related_tasks_displayed.map((t) => t.id)

      if (this.interaction_date) {
        data["interaction_date"] = this.$moment(this.interaction_date)
          .set("hour", this.$moment().hour())
          .set("minute", this.$moment().minute())
          .set("second", this.$moment().second())
          .toISOString()
      } else {
        data["interaction_date"] = null
      }
      data["record"] = this.selected_company?.id
      data["description"] = this.interaction_description

      if (data.type == "meeting") {
        data["meta_data"] = {
          when: {
            object: "timespan",
            end_time: this.$moment(
              `${this.interaction_date.getFullYear()}-${this.interaction_date.getMonth() + 1}-${this.interaction_date.getDate()} ${
                this.end_time?.split(" (")[0]
              }`,
              "YYYY-MM-DD hh:mm A"
            ).unix(),
            start_time: this.$moment(
              `${this.interaction_date.getFullYear()}-${this.interaction_date.getMonth() + 1}-${this.interaction_date.getDate()} ${
                this.start_time
              }`,
              "YYYY-MM-DD hh:mm A"
            ).unix()
          }
        }
      }

      if (
        this.$store.state.data.interaction_types.filter((inter) => inter.value === values["type"])[0].categories.length &&
        !values["category"]
      ) {
        this.category_error_message = this.$t("Category is required")
      } else if (!this.start_time && data["type"] == "meeting") {
        this.start_time_error_message = this.$t("required")
      } else if (!this.end_time && data["type"] == "meeting") {
        this.end_time_error_message = this.$t("required")
      } else {
        if (this.inPlaybook) {
          data["companies"] = this.selected_companies.map((c) => (c.id ? c.id : c))
          if (this.attachments.length) {
            const new_attachments = this.attachments.filter((att) => typeof att.file !== "string")
            const old_attachments = this.attachments.filter((att) => typeof att.file == "string")

            let attachment_calc = old_attachments.map((att) => att.id)

            if (new_attachments.length) {
              dataService.addAttachment({ attachments: new_attachments }).then((res) => {
                attachment_calc = attachment_calc.concat(res.data.map((a) => a.id))
                data["attachments"] = attachment_calc

                this.$emit("done", data)
              })
            } else {
              data["attachments"] = attachment_calc
              this.$emit("done", data)
            }
          } else {
            this.$emit("done", data)
          }
        } else {
          this.submitting_is_on = true
          this.$store
            .dispatch("data/updateInteraction", {
              interaction: data,
              record: this.$store.state.ui.currentCompany
            })
            .then((res) => {
              let formData = new FormData()

              if (this.new_attachments.length) {
                this.new_attachments.forEach((attachment, i) => {
                  Object.keys(attachment).forEach((field) => formData.append(`attachments[${i}][${field}]`, attachment[field]))
                })
                this.$store.dispatch("data/addAttachmentsToInteraction", {
                  id: res.id,
                  attachments: formData
                })
              }
              if (this.deleted_attachments.length) {
                this.$store.dispatch("data/deleteAttachmentsFromInteraction", {
                  id: res.id,
                  attachments_ids: this.deleted_attachments.map((x) => x.id)
                })
              }

              this.$emitter.emit(
                ALL_EMITTERS.NEW_ACTINON_CREATED_OR_UPDATED,
                this.interaction_date ? new Date(this.interaction_date) : null
              )

              this.$emitter.emit(ALL_EMITTERS.INTERACTION_UPDATED, res)
              this.$emitter.emit(ALL_EMITTERS.INTERACTION_UPDATED_IN_AI_PROMPT, res)

              this.submitting_is_on = false
              this.$emit("done", res)
            })
            .catch(() => {
              this.submitting_is_on = false
              // To do show exceptions
              this.$emit("error")
            })
        }
      }
    }
  }
}
</script>
